const preloader = (() => {
  function init() {
    setTimeout(() => {
      document.querySelector("body").classList.add("loaded");
    }, 4000);
  }

  return {
    init,
  };
})();

export default preloader;
